// extracted by mini-css-extract-plugin
module.exports = {"box":"box___3GdMo","url":"url___1-uXQ","icon":"icon___1lpeR","boxer":"boxer___t3EI2","href":"href___aOHYG","flex":"flex___3uJyq"};